import api from '@/plugins/request/index';

// 待办任务待处理列表
export const getTaskPendingList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/task/pending`, params).then(res => res);
}
// 待办任务已处理列表
export const getTaskCompletedList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/task/completed`, params).then(res => res);
}
// 待办任务添加
export const setTask = async (params, type = 'post') => {
  return api[type](`/gateway/v1/task`, params).then(res => res);
}
// 待办任务修改状态
export const setTaskStatus = async (params, type = 'put') => {
  return api[type](`/gateway/v1/task/pending/${params.id}/status`, params).then(res => res);
}
// 待办任务删除
export const deleteTask = async (params, type = 'delete') => {
  return api[type](`/gateway/v1/task`, params).then(res => res);
}
// 待办任务泳道拖拽
export const dragTask = async (params, type = 'put') => {
  return api[type](`/gateway/v1/task/pending/${params.id}/lane`, params).then(res => res);
}
// 待办任务修改截止日期
export const editTaskDealTime = async (params, type = 'put') => {
  return api[type](`/gateway/v1/task/pending/${params.id}/deadline`, params).then(res => res);
}
// 待办任务更新任务级别
export const editTaskLevel = async (params, type = 'put') => {
  return api[type](`/gateway/v1/task/pending/${params.id}/level`, params).then(res => res);
}
// 待办任务更新完成状态
export const editTaskCompelete = async (params, type = 'put') => {
  return api[type](`/gateway/v1/task/pending/${params.id}/status`, params).then(res => res);
}
// 业绩任务详情
export const getTaskPerformance = async (id, type = 'get') => {
  return api[type](`/gateway/v1/task/target-task/${id}`).then(res => res);
}
// 普通任务详情
export const getTaskGeneral = async (id, type = 'get') => {
  return api[type](`/gateway/v1/task/common-task/${id}`).then(res => res);
}
// 业绩目标列表
export const getPerformanceList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/task/target`, params).then(res => res);
}
// 业绩目标添加
export const setPerformance = async (params, type = 'post') => {
  return api[type](`/gateway/v1/task/target`, params).then(res => res);
}
// 业绩目标详情
export const getPerformance = async (id, type = 'get') => {
  return api[type](`/gateway/v1/task/target/${id}`).then(res => res);
}
// 业绩目标编辑
export const editPerformance = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/task/target/${id}`, params).then(res => res);
}
// 业绩目标删除
export const deletePerformance = async (id, type = 'delete') => {
  return api[type](`/gateway/v1/task/target/${id}`).then(res => res);
}
// 业绩目标执行范围
export const getPerformanceRange = async (params, type = 'get') => {
  return api[type](`/gateway/v1/task/target/select-target`, params).then(res => res);
}
// 获取经纪人详情
export const getAdminInfo = async (id, type = 'get') => {
  return api[type](`/gateway/v1/admin/${id}/simple`).then(res => res);
}
// 获取整个公司人列表
export const getCompanyAll = async (type = 'get') => {
  return api[type](`/gateway/v1/dept/list-by-permission`).then(res => res);
}
// 获取业绩总览
export const getPerformanceTotal = async (params, type = 'get') => {
  return api[type](`/gateway/v1/task-report/target/overview`, params).then(res => res);
}
// 获取业绩明细
export const getPerformanceTask = async (params, type = 'get') => {
  return api[type](`/gateway/v1/task-report/target/show-list`, params).then(res => res);
}
// 获取经纪人未完成任务
export const getUnFinishTask = async (id, type = 'get') => {
  return api[type](`/gateway/v1/task/customer/${id}/nearest-follow-task`).then(res => res);
}
// 业务统计导出
export const taskExport = async (params, type = 'get') => {
  return api[type](`/gateway/v1/task-report/target/export-list`, params).then(res => res);
}

